import { Producto } from "./producto";
import { Accesorio } from "./accesorio";
import { Imagen } from "./imagen";
import { TipoPlazo } from "./tipo-plazo";

export class Item {
    private _imagenDestacada: Imagen;

    constructor(
        public IdItem: number | string = null,
        public producto: Producto = null,
        public cantidad: number = null,
        public precioUnitario: number = 0,
        public etiqueta: string = '',
        public customDescripcion: string = '',
        public accesorios: Accesorio[] = <Accesorio[]>[],
        public especial: boolean = false,
        public productoPrecioIncluido: boolean = false,
        public tipoPlazo: TipoPlazo = new TipoPlazo()
    ) { }

    /**
     * El item toma una imagen del producto y la pone como destacada
     * Se usa por ejemplo en la impresión de una cotización
     * @param imagen imagen que se debe setear como la destacada del ítem
     */
    setImagenDestacada(imagen: Imagen): void {
        this._imagenDestacada = imagen;
    }

    /**
     * retorn la imagen destacada del ítem;
     */
    getImagenDestacada(): Imagen {
        return this._imagenDestacada;
    }

    /**
     * Busca el accesorio recibido entre los accesorios del item y retorna true si lo encuentra
     * @param accesorio     
     * @returns boolean true si el item contiene el accesorio, false otro caso
     */
    hasAccesorio(accesorio: Accesorio) {
        var index = this.accesorios.length;
        while (index--) {
            if (this.accesorios[index].IdAccesorio == accesorio.IdAccesorio) {
                return true;
            }
        }

        return false;
    }

    getAccesorio(accesorio: Accesorio): Accesorio | null {
        var index = this.accesorios.length;
        while (index--) {
            if (this.accesorios[index].IdAccesorio == accesorio.IdAccesorio) {
                return this.accesorios[index];
            }
        }

        return null;
    }

    /**
     * @returns retorna el importe asignado a un accesorio
     */
    getAccesorioImporteAsignado(accesorio: Accesorio): number {
        var index = this.accesorios.length;
        while (index--) {
            if (this.accesorios[index].IdAccesorio == accesorio.IdAccesorio) {
                return this.accesorios[index].importeAsignado ? this.accesorios[index].importeAsignado : 0.00;
            }
        }

        return null;
    }

    /**
     * @returns retorna la sumatoria de importeAsignado * cantidad para cada accesorio
     */
    calcularTotalAccesorios(): number {
        var total = 0.00;

        var index = this.accesorios.length;
        while (index--) {
            total += (+this.accesorios[index].importeAsignado || 0.00) * (+this.accesorios[index].cantidad || 0);
        }

        return total;
    }

    calcularTotal(): number {
        return (+this.precioUnitario || 0) * (this.cantidad || 0) + this.calcularTotalAccesorios();
    }
}